var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "search-quote-card card mx-0 p-0" }, [
      _c("div", { staticClass: "fixed-grid has-12-cols p-1" }, [
        _c("div", { staticClass: "grid" }, [
          _c("div", { staticClass: "cell is-col-span-4" }, [
            _c("figure", { staticClass: "image is-128x128 p-3" }, [
              _c("div", { staticClass: "skeleton-image" }),
            ]),
          ]),
          _c("div", { staticClass: "cell is-col-span-8" }, [
            _c(
              "div",
              {
                staticClass: "is-flex is-flex-direction-column is-size-7",
                staticStyle: { width: "100%" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "is-flex is-align-items-center is-justify-content-space-between has-background-grey-lighter p-1",
                  },
                  [
                    _c("div", {
                      staticClass: "skeleton-text skeleton-text-medium",
                    }),
                    _c("div", {
                      staticClass: "skeleton-text skeleton-text-small",
                    }),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "is-flex is-align-items-center is-justify-content-space-between my-2",
                  },
                  [
                    _c("div", {
                      staticClass: "skeleton-text skeleton-text-large",
                    }),
                    _c("div", {
                      staticClass: "skeleton-text skeleton-text-small",
                    }),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "is-flex is-align-items-center is-justify-content-space-between mb-2",
                  },
                  [
                    _c("div", {
                      staticClass: "skeleton-text skeleton-text-medium",
                    }),
                    _c("div", {
                      staticClass: "skeleton-text skeleton-text-small",
                    }),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "is-flex is-align-items-center is-justify-content-space-between",
                  },
                  [
                    _c("div", {
                      staticClass: "skeleton-text skeleton-text-medium",
                    }),
                    _c("div", {
                      staticClass: "skeleton-text skeleton-text-large",
                    }),
                  ]
                ),
              ]
            ),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }